import { z } from "zod";
const MAX_OBJECT_METADATA_BYTES = 1024 * 1024;
function getJsonByteLength(value) {
    return new TextEncoder().encode(JSON.stringify(value)).length;
}
export const DTOObjectMetadata = z
    .lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(DTOObjectMetadata),
    z.record(DTOObjectMetadata),
]))
    .superRefine((metadata, ctx) => {
    if (getJsonByteLength(metadata) > MAX_OBJECT_METADATA_BYTES) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Object metadata must be 1MB or smaller.",
        });
    }
})
    .describe("Optional JSON metadata for extra structured details. Must be 1MB or smaller when serialized.");
